/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Card, Col, DatePicker, Form, Input, InputNumber, message } from 'antd';
import axios from 'axios';

import Utils from '../../../../Assets/Scripts/Utils';
import MapLocationPicker from '../../../../Components/MapLocationPicker/MapLocationPicker';
import { createShowField } from '../../../../Components/ResourceFieldLayout/shouldRenderTaskField';

function FormLogisticFieldsComponent({
  fieldsPermissions,
  form,
  task,
  isTaskReadOnly,
  isEditing,
  showInstructorInCompanyFields,
  settings,
  fieldLayout,
  roleId,
  fieldNameFilter,
  hideSectionCard,
}) {
  const showField = createShowField(fieldsPermissions, fieldLayout, roleId, fieldNameFilter);
  const [mapLocation, setMapLocation] = useState(null);

  useEffect(() => {
    const formValues = form.getFieldsValue();
    if (formValues.latitude && formValues.longitude) {
      const lat = parseFloat(formValues.latitude);
      const lng = parseFloat(formValues.longitude);

      if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
        setMapLocation({
          lat,
          lng,
        });
      }
    }
  }, [form]);

  const getAdressByCEP = async (cep) => {
    const cleanCep = cep.replace(/[-_]/g, '');
    if (cleanCep?.length === 8) {
      const address = await axios
        .get(`https://viacep.com.br/ws/${cleanCep}/json`)
        .then((res) => res.data)
        .catch((error) => {
          Utils.logError(error);
          message.error('Erro ao buscar CEP!');
          return null;
        });

      if (address && !address.erro) {
        const data = {};
        data.streetLogistic = address.logradouro;
        data.districtLogistic = address.bairro;
        data.cityLogistic = address.localidade;
        data.stateLogistic = address.uf;
        data.complementLogistic = address.complemento;

        form.setFieldsValue({ ...form.getFieldsValue(), ...data });
      } else {
        message.error('Oops. CEP não encontrado!');
      }
    }
  };

  const handleLocationSelect = (addressData) => {
    if (!addressData || !addressData.coordinates) {
      return;
    }

    const currentValues = form.getFieldsValue();
    const hasLocationChanged =
      currentValues.latitude !== addressData.coordinates.latitude ||
      currentValues.longitude !== addressData.coordinates.longitude;

    if (!hasLocationChanged) {
      return;
    }

    const updatedData = {
      ...currentValues,
      ...addressData,
      latitude: addressData.coordinates.latitude,
      longitude: addressData.coordinates.longitude,
    };

    setTimeout(() => {
      form.setFieldsValue(updatedData);
      message.success('Localização e endereço atualizados!');
    }, 100);
  };

  const inner = (
    <>
      {/* Quando Avançado 24 horas Hibrido (Endereço Teoria) */}
      {showField('Advance24h') && (
        <Col span={24}>
          <Form.Item
            name="advance24h"
            label="Quando Avançado 24 horas Hibrido (Endereço Teoria)"
            rules={[
              {
                required: fieldsPermissions?.Advance24h.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.Advance24h.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Endereço de Parada Transporte */}
      {showField('TransportStopAddress') && (
        <Col span={24}>
          <Form.Item
            name="transportStopAddress"
            label="Endereço de Parada Transporte"
            rules={[
              {
                required: fieldsPermissions?.TransportStopAddress.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.TransportStopAddress.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Ponto de Referência */}
      {showField('ReferencePoint') && (
        <Col span={24}>
          <Form.Item
            name="referencePoint"
            label="Ponto de Referência"
            rules={[
              {
                required: fieldsPermissions?.ReferencePoint.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.ReferencePoint.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Nome Responsável */}
      {showField('ResponsiblePersonNameLogistic') && (
        <Col span={24}>
          <Form.Item
            name="responsiblePersonNameLogistic"
            label="Nome Responsável"
            rules={[
              {
                required: fieldsPermissions?.ResponsiblePersonNameLogistic.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 // Sempre bloqueado no estágio 5 (Concluído)
                  ? true
                  : fieldsPermissions?.ResponsiblePersonNameLogistic.access !== 2 ||
                    isTaskReadOnly ||
                    !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Telefone Responsável */}
      {showField('ResponsiblePersonPhoneLogistic') && showInstructorInCompanyFields && (
        <Col span={24}>
          <Form.Item
            name="responsiblePersonPhoneLogistic"
            label="Telefone Responsável"
            rules={[
              {
                required: fieldsPermissions?.ResponsiblePersonPhoneLogistic.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.ResponsiblePersonPhoneLogistic.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* E-mail Responsável */}
      {showField('ResponsiblePersonEmailLogistic') && (
        <Col span={24}>
          <Form.Item
            name="responsiblePersonEmailLogistic"
            label="E-mail Responsável"
            rules={[
              {
                required: fieldsPermissions?.ResponsiblePersonEmailLogistic.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.ResponsiblePersonEmailLogistic.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Componente do Mapa */}
      {showField('MapLocation') && (
        <Col span={24} style={{ marginTop: 16 }}>
          <Form.Item
            label="Localização"
            required={fieldsPermissions?.MapLocation.isRequired}
            rules={[
              {
                validator: async () => {
                  if (fieldsPermissions?.MapLocation.isRequired) {
                    const formValues = form.getFieldsValue();
                    const hasLatitude = formValues.latitude && formValues.latitude !== '';
                    const hasLongitude = formValues.longitude && formValues.longitude !== '';

                    if (!hasLatitude || !hasLongitude) {
                      return Promise.reject(
                        new Error('Por favor, selecione uma localização no mapa')
                      );
                    }
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <MapLocationPicker
              value={mapLocation}
              onChange={setMapLocation}
              onLocationSelect={handleLocationSelect}
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.MapLocation.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              height={350}
              settings={settings}
            />
          </Form.Item>
        </Col>
      )}

      {/* Campos ocultos para coordenadas */}
      <>
        <Form.Item name="latitude" hidden>
          <Input />
        </Form.Item>
        <Form.Item name="longitude" hidden>
          <Input />
        </Form.Item>
      </>

      {/* CEP */}
      {showField('PostalCodeLogistic') && showInstructorInCompanyFields && (
        <Col span={24}>
          <Form.Item
            name="postalCodeLogistic"
            label="CEP"
            rules={[
              {
                required: fieldsPermissions?.PostalCodeLogistic?.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              id="postalCodeLogistic"
              maxLength={9}
              placeholder="o campo está vazio"
              onChange={(e) => getAdressByCEP(e.target.value)}
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.PostalCodeLogistic.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Rua */}
      {showField('StreetLogistic') && showInstructorInCompanyFields && (
        <Col span={24}>
          <Form.Item
            name="streetLogistic"
            label="Rua"
            rules={[
              {
                required: fieldsPermissions?.StreetLogistic.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.StreetLogistic.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Número */}
      {showField('NumberLogistic') && showInstructorInCompanyFields && (
        <Col span={24}>
          <Form.Item
            name="numberLogistic"
            label="Número"
            rules={[
              {
                required: fieldsPermissions?.NumberLogistic.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.NumberLogistic.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Bairro */}
      {showField('DistrictLogistic') && showInstructorInCompanyFields && (
        <Col span={24}>
          <Form.Item
            name="districtLogistic"
            label="Bairro"
            rules={[
              {
                required: fieldsPermissions?.DistrictLogistic.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DistrictLogistic.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Cidade */}
      {showField('CityLogistic') && showInstructorInCompanyFields && (
        <Col span={24}>
          <Form.Item
            name="cityLogistic"
            label="Cidade"
            rules={[
              {
                required: fieldsPermissions?.CityLogistic.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.CityLogistic.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Estado */}
      {showField('StateLogistic') && showInstructorInCompanyFields && (
        <Col span={24}>
          <Form.Item
            name="stateLogistic"
            label="Estado"
            rules={[
              {
                required: fieldsPermissions?.StateLogistic.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.StateLogistic.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Complemento */}
      {showField('ComplementLogistic') && showInstructorInCompanyFields && (
        <Col span={24}>
          <Form.Item
            name="complementLogistic"
            label="Complemento"
            rules={[
              {
                required: fieldsPermissions?.ComplementLogistic.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.ComplementLogistic.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Reembolso */}
      {showField('Refund') && (
        <Col span={24}>
          <Form.Item
            name="refund"
            label="Reembolso"
            rules={[
              {
                required: fieldsPermissions?.Refund.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <InputNumber
              min={0}
              step={0.0001}
              formatter={Utils.priceFormatter}
              parser={Utils.priceParser}
              style={{ width: '100%' }}
              placeholder="o campo está vazio"
              disabled={
                task?.stage?.id === 5
                  ? !isEditing // Habilitado se isEditing for true no estágio 5
                  : fieldsPermissions?.Refund.access !== 2 || isTaskReadOnly || !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Valor Pago Transporte */}
      {showField('AmountPaidTransportation') && (
        <Col span={24}>
          <Form.Item
            name="amountPaidTransportation"
            label="Valor Pago Transporte"
            rules={[
              {
                required: fieldsPermissions?.AmountPaidTransportation.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <InputNumber
              min={0}
              step={0.0001}
              formatter={Utils.priceFormatter}
              parser={Utils.priceParser}
              style={{ width: '100%' }}
              placeholder="o campo está vazio"
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.AmountPaidTransportation.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Data de Confirmação */}
      {showField('ConfirmationDate') && (
        <Col span={24}>
          <Form.Item
            name="confirmationDate"
            label="Data de Confirmação"
            rules={[
              {
                required: fieldsPermissions?.ConfirmationDate.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{
                borderRadius: 16,
              }}
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.ConfirmationDate.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Confirmado por */}
      {showField('ConfirmedBy') && (
        <Col span={24}>
          <Form.Item
            name="confirmedBy"
            label="Confirmado por"
            rules={[
              {
                required: fieldsPermissions?.ConfirmedBy.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.ConfirmedBy.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Nome Responsável Confirmação */}
      {showField('NameResponsibleConfirmation') && (
        <Col span={24}>
          <Form.Item
            name="nameResponsibleConfirmation"
            label="Nome Responsável Confirmação"
            rules={[
              {
                required: fieldsPermissions?.NameResponsibleConfirmation.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.NameResponsibleConfirmation.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* E-mail Responsável Confirmação */}
      {showField('EmailResponsibleConfirmation') && (
        <Col span={24}>
          <Form.Item
            name="emailResponsibleConfirmation"
            label="E-mail Responsável Confirmação"
            rules={[
              {
                required: fieldsPermissions?.EmailResponsibleConfirmation.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.EmailResponsibleConfirmation.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Telefone Responsável Confirmação */}
      {showField('PhoneResponsibleConfirmation') && showInstructorInCompanyFields && (
        <Col span={24}>
          <Form.Item
            name="phoneResponsibleConfirmation"
            label="Telefone Responsável Confirmação"
            rules={[
              {
                required: fieldsPermissions?.PhoneResponsibleConfirmation.isRequired,
                message: 'Telefone do responsável pela Confirmação',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.PhoneResponsibleConfirmation.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}
    </>
  );

  if (hideSectionCard) {
    return inner;
  }

  return (
    <Col span={24}>
      <Card title="Logística" bordered={false} className="task-form-section-card">
        {inner}
      </Card>
    </Col>
  );
}

export default FormLogisticFieldsComponent;
